import "./App.css";
import Controls from "./Components/Controls";

function App() {
  return (
    <div className="stage">
      <Controls />
    </div>
  );
}

export default App;
